import { useContext } from 'react';

import { PdfOptions } from '@breathelife/types';
import { PdfContext, PdfContextProps } from './PdfContext';

const usePdfContext = (): PdfContextProps<PdfOptions> => {
  const pdfContext = useContext<PdfContextProps<PdfOptions>>(PdfContext);
  return pdfContext;
};

export default usePdfContext;
